// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { passwordRequirementsValidatorStyles } from "@ces/App/Components/Common/PasswordRequirements";
import { color, getSystemColor, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

passwordRequirementsValidatorStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

passwordRequirementsValidatorStyles.passwordRequirement = {
    css: css`
        font-size: 16px;
        line-height: 26px;
        color: ${({ passedRequirement, hasTyped }: any) =>
            !hasTyped ? color("text") : passedRequirement ? color("success") : color("danger")};
        display: flex;
        gap: 4px;
        align-items: center;

        ${xScreen("lte", "md")} {
            align-items: start;
        }

        .icon {
            width: ${({ hasTyped }: any) => (hasTyped ? "12px" : "5px")};
            min-width: ${({ hasTyped }: any) => (hasTyped ? "13px" : "5px")};
            height: ${({ hasTyped }: any) => (hasTyped ? "12px" : "5px")};
            background: ${({ hasTyped }: any) => (hasTyped ? "transparent" : `${getSystemColor("common.black")}`)};
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;

            ${xScreen("lte", "md")} {
                margin-top: ${({ hasTyped }: any) => (hasTyped ? "8px" : "10px")};
            }
        }
    `,
};
